import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {NotificationsActions} from '@store/notifications/notifications.actions';
import {Store} from '@ngrx/store';
import {NotificationsSelectors} from '@store/notifications/notifications.selectors';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {Notification} from '@store/notifications/notifications.types';
import {MatDivider} from '@angular/material/divider';
import {TruncateDirective} from '@aviary/directives/truncate.directive';
import {IconButtonComponent} from '@aviary/buttons/icon-button/icon-button.component';

@Component({
  selector: 'px-notification-list-item',
  templateUrl: './notification-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, MatIcon, SelectPipe, FormatPipe, MatDivider, TruncateDirective, IconButtonComponent]
})
export class NotificationListItemComponent {

  @Input({required: true}) notification: Notification;
  @Input() showDivider: boolean = true;
  public readonly store = inject(Store);
  public readonly statelessNotificationsSelectors = NotificationsSelectors.Stateless;
  public readonly viewportSelectors = ViewportSelectors;

  public clearNotification(notificationId: number): void {
    this.store.dispatch(NotificationsActions.markNotificationAsRead(notificationId));
  }
}
